import {
    animation, trigger, animateChild, group,
    transition, animate, style, query
  } from '@angular/animations';
  
  // Routable animations
  export const slideInAnimation =
  trigger('routeAnimations', [
    transition('* <=> *', [
      // Set a default  style for enter and leave
      query(':enter, :leave', 
        [
          style({
            position: 'absolute',
            left: 0,
            width: '100%',
            opacity: 0,
          }),
        ], 
        { optional: true }
      ),
      // Animate the new page in
      query(':enter', 
        [
          animate('600ms ease', style({ opacity: 1})),
        ], 
        { optional: true } 
      )
    ]),
]);
  
  
  /*
  Copyright Google LLC. All Rights Reserved.
  Use of this source code is governed by an MIT-style license that
  can be found in the LICENSE file at http://angular.io/license
  */